module.exports = {"name":"SPPC","sections":[{"pages":[{"steps":[{"component":{"className":"address-variant","requiredData":{"allof":[{"field":"postalCode","type":"formValues","minLength":4},{"_delete":true}]},"props":[{},{"_delete":true}]}}]}]},{},{},{"name":"Dit køretøj","pages":[{},{"steps":[{"component":{"onLoad":[{"props":{"services":[{"serviceParams":[{},{},{"field":"street","required":true,"value":""},{"field":"houseNumber","required":true,"value":""},{},{},{},{},{},{},{},{}]}]}}]}}]}]},{}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/packages/insuranceCheck/package.insuranceCheckAddressVariant.json
// module id = 663
// module chunks = 0